import React from 'react';
import PropTypes from 'prop-types';
import { Form, Button, Modal } from 'react-bootstrap';

const ImportarCuentasModal = ({ show, onHide, onProcess }) => {
  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>Importar Catálogo de Cuentas</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>Sube un archivo Excel o CSV con la estructura del catálogo.</p>
        <Form.Group controlId="formFile" className="mb-3">
          <Form.Label>Archivo de importación</Form.Label>
          <Form.Control type="file" accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" />
        </Form.Group>
        <div className="text-muted small">
          <p className="mb-1">El archivo debe contener las siguientes columnas:</p>
          <ul>
            <li>Código de Cuenta</li>
            <li>Nombre de Cuenta</li>
            <li>ID Padre (Opcional)</li>
            <li>ID Tipo Cuenta</li>
            <li>Nivel</li>
            <li>Es Afectable (0 o 1)</li>
            <li>Naturaleza (D o A)</li>
          </ul>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>Cancelar</Button>
        <Button variant="success" onClick={onProcess}>Procesar Archivo</Button>
      </Modal.Footer>
    </Modal>
  );
};

ImportarCuentasModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  onProcess: PropTypes.func.isRequired
};

export default ImportarCuentasModal;
